import type { TableSessionModel } from '..';
import type { Column } from '../../dataTable/columns';
import { sortByLocale, sortByValue } from '../../sortBy';
import { renderCarbonOffset, renderChargingCost, renderStopReason } from './render';
import { searchCarbonOffset, searchChargingCost, searchStopReason } from './search';

export function sessionIdColumn(): Column<TableSessionModel> {
  return { field: 'id', title: 'Session ID', type: 'numeric', hidden: true };
}

export function evseIdColumn(): Column<TableSessionModel> {
  return { title: 'EVSE ID', field: 'evseId', hidden: true };
}

export function connectorIdColumn(): Column<TableSessionModel> {
  return { field: 'connectorId', title: 'Connector ID', hidden: true };
}

export function stopReasonColumn(): Column<TableSessionModel> {
  return {
    field: 'stopReason',
    title: 'Stop reason',
    render: renderStopReason,
    customFilterAndSearch: searchStopReason,
  };
}

export function carbonOffsetColumn(): Column<TableSessionModel> {
  return {
    field: 'carbonOffset',
    title: 'Carbon offset',
    customSort: sortByValue('carbonOffset'),
    render: renderCarbonOffset,
    customFilterAndSearch: searchCarbonOffset,
  };
}

export function costColumn(): Column<TableSessionModel> {
  return {
    field: 'cost.amount',
    title: 'Total cost',
    customSort: sortByValue('cost.amount'),
    render: ({ cost }) => renderChargingCost(cost),
    customFilterAndSearch: (searchValue: unknown, { cost }) => searchChargingCost({ searchValue, cost }),
  };
}

export function reimbursementFigureColumn(args: { isDisplayed: boolean }): Column<TableSessionModel> {
  const { isDisplayed } = args;
  return {
    field: 'reimbursementFigure',
    title: 'Reimbursement figure',
    render: ({ reimbursementFigure }) => renderChargingCost(reimbursementFigure),
    customFilterAndSearch: (searchValue: unknown, { reimbursementFigure }) =>
      searchChargingCost({ searchValue, cost: reimbursementFigure }),
    hidden: !isDisplayed,
    removable: isDisplayed,
  };
}

export function tokenUidColumn(): Column<TableSessionModel> {
  return { field: 'token.uid', title: 'Token UID', customSort: sortByLocale('token.uid'), hidden: true };
}

export function tokenIdColumn(): Column<TableSessionModel> {
  return { field: 'token.id', title: 'Token ID', customSort: sortByLocale('token.id') };
}

export function tokenNameColumn(): Column<TableSessionModel> {
  return { field: 'token.name', title: 'Token name', customSort: sortByLocale('token.name') };
}
